const temperatureColorPalette = [
  { value: '-40', color: '#1a237e' },
  { value: '-35', color: '#283593' },
  { value: '-30', color: '#3949ab' },
  { value: '-25', color: '#5e6fc8' },
  { value: '-20', color: '#5c6bc0' },
  { value: '-15', color: '#4fc3f7' },
  { value: '-10', color: '#42a5f5' },
  { value: '-5', color: '#81d4fa' },
  { value: '0', color: '#90caf9' },
  { value: '5', color: '#a5d6a7' },
  { value: '10', color: '#66bb6a' },
  { value: '15', color: '#9ccc65' },
  { value: '20', color: '#ffeb3b' },
  { value: '25', color: '#ffc947' },
  { value: '30', color: '#ff7043' },
  { value: '35', color: '#ef5350' },
  { value: '40', color: '#c62828' },
  { value: '45', color: '#8b0000' },
  { value: '50', color: '#4a0000' }
];

export const legendConfigs: { [key: string]: any } = {
  'PrecipitationTotal': {
    items: [
      { value: '0', color: '#FFFFFF' },
      { value: '10', color: '#CCE5FF' },
      { value: '20', color: '#99CCFF' },
      { value: '30', color: '#66B3FF' },
      { value: '40', color: '#3399FF' },
      { value: '50', color: '#0080FF' },
      { value: '60', color: '#0066CC' },
      { value: '70', color: '#004C99' },
      { value: '80', color: '#003366' },
      { value: '90', color: '#001A33' },
      { value: '100', color: '#000000' }
    ]
  },
  'Humidity': {
    items: [
      { value: '0', color: '#ffffff' },
      { value: '10', color: '#e6f7ff' },
      { value: '20', color: '#bae7ff' },
      { value: '30', color: '#91d5ff' },
      { value: '40', color: '#69c0ff' },
      { value: '50', color: '#40a9ff' },
      { value: '60', color: '#1890ff' },
      { value: '70', color: '#096dd9' },
      { value: '80', color: '#0050b3' },
      { value: '90', color: '#003a8c' },
      { value: '100', color: '#002766' }
    ]
  },
  'Fallout': {
    items: [
      { value: '0', color: '#FFFFFF' },
      { value: '10', color: '#CCE5FF' },
      { value: '20', color: '#99CCFF' },
      { value: '30', color: '#66B3FF' },
      { value: '40', color: '#3399FF' },
      { value: '50', color: '#0080FF' },
      { value: '60', color: '#0066CC' },
      { value: '70', color: '#004C99' },
      { value: '80', color: '#003366' },
      { value: '90', color: '#001A33' },
      { value: '100', color: '#000000' }
    ]
  },
  'TemperatureAverage': { items: temperatureColorPalette },
  'TemperatureMax': { items: temperatureColorPalette },
  'TemperatureMin': { items: temperatureColorPalette },
  'TemperatureMinTotal': { items: temperatureColorPalette },
  'TemperatureMaxTotal': { items: temperatureColorPalette },
  'FrostDanger': {
    items: [
      { value: 'NOT_FROST_DANGEROUS', color: '#4CAF50' }, // Green - not frost dangerous
      { value: 'FROST_DANGEROUS', color: '#2196F3' }      // Blue - frost dangerous
    ]
  },
  'TemperatureAverageTotal': { items: temperatureColorPalette },
  'WindSpeed': {
    items: [
      { value: '0 м/с', color: '#ffffff' },
      { value: '5 м/с', color: '#ccffcc' },
      { value: '10 м/с', color: '#99ff99' },
      { value: '15 м/с', color: '#66ff66' },
      { value: '20 м/с', color: '#33cc33' },
      { value: '25 м/с', color: '#009900' }
    ]
  },
  'PrecipitationDeviation': {
    items: [
      { value: '-100%', color: '#8b0000' },
      { value: '-50%', color: '#ff4444' },
      { value: '0%', color: '#ffffff' },
      { value: '+50%', color: '#4444ff' },
      { value: '+100%', color: '#000088' }
    ]
  },
  'TemperatureDeviation': {
    items: [
      { value: '-5', color: '#0000ff' },
      { value: '-3', color: '#4444ff' },
      { value: '0', color: '#ffffff' },
      { value: '+3', color: '#ff4444' },
      { value: '+5', color: '#ff0000' }
    ]
  },
  'SolarRadiationInfluence': {
    items: [
      { value: '0', color: '#FFF7BC' },
      { value: '889', color: '#FECE64' },
      { value: '1 778', color: '#FBAC43' },
      { value: '2 667', color: '#F78921' },
      { value: '3 556', color: '#EA7919' },
      { value: '4 444', color: '#DD6912' },
      { value: '5 333', color: '#C34802' },
      { value: '6 222', color: '#953704' },
      { value: '7 111', color: '#7D2E05' },
      { value: '8 000', color: '#4C1900' }
    ]
  },
  'SumOfActiveTemperaturesBase5': {
    items: [
      { value: '0', color: '#313795' },
      { value: '778', color: '#5D7AB8' },
      { value: '1556', color: '#88BDDA' },
      { value: '2333', color: '#C1DDD1' },
      { value: '3111', color: '#F9FDC8' },
      { value: '3889', color: '#F9CA8F' },
      { value: '4667', color: '#F9B173' },
      { value: '5444', color: '#F99756' },
      { value: '6222', color: '#D04C3E' },
      { value: '7000', color: '#A60026' }
    ]
  },
  'SumOfActiveTemperaturesBase7': {
    items: [
      { value: '0', color: '#313795' },
      { value: '778', color: '#5D7AB8' },
      { value: '1556', color: '#88BDDA' },
      { value: '2333', color: '#C1DDD1' },
      { value: '3111', color: '#F9FDC8' },
      { value: '3889', color: '#F9CA8F' },
      { value: '4667', color: '#F9B173' },
      { value: '5444', color: '#F99756' },
      { value: '6222', color: '#D04C3E' },
      { value: '7000', color: '#A60026' }
    ]
  },
  'SumOfActiveTemperaturesBase10': {
    items: [
      { value: '0', color: '#313795' },
      { value: '778', color: '#5D7AB8' },
      { value: '1556', color: '#88BDDA' },
      { value: '2333', color: '#C1DDD1' },
      { value: '3111', color: '#F9FDC8' },
      { value: '3889', color: '#F9CA8F' },
      { value: '4667', color: '#F9B173' },
      { value: '5444', color: '#F99756' },
      { value: '6222', color: '#D04C3E' },
      { value: '7000', color: '#A60026' }
    ]
  },
  'SumOfActiveTemperaturesBase12': {
    items: [
      { value: '0', color: '#313795' },
      { value: '778', color: '#5D7AB8' },
      { value: '1556', color: '#88BDDA' },
      { value: '2333', color: '#C1DDD1' },
      { value: '3111', color: '#F9FDC8' },
      { value: '3889', color: '#F9CA8F' },
      { value: '4667', color: '#F9B173' },
      { value: '5444', color: '#F99756' },
      { value: '6222', color: '#D04C3E' },
      { value: '7000', color: '#A60026' }
    ]
  },
  'SumOfActiveTemperaturesBase15': {
    items: [
      { value: '0', color: '#313795' },
      { value: '778', color: '#5D7AB8' },
      { value: '1556', color: '#88BDDA' },
      { value: '2333', color: '#C1DDD1' },
      { value: '3111', color: '#F9FDC8' },
      { value: '3889', color: '#F9CA8F' },
      { value: '4667', color: '#F9B173' },
      { value: '5444', color: '#F99756' },
      { value: '6222', color: '#D04C3E' },
      { value: '7000', color: '#A60026' }
    ]
  },
  'SumOfFallout': {
    items: [
      { value: '0', color: '#313795' },
      { value: '333', color: '#5D7AB8' },
      { value: '667', color: '#729CC9' },
      { value: '1000', color: '#88BDDA' },
      { value: '1333', color: '#F9FDC8' },
      { value: '1667', color: '#F9CA8F' },
      { value: '2000', color: '#F9B173' },
      { value: '2333', color: '#F99756' },
      { value: '2667', color: '#D04C3E' },
      { value: '3000', color: '#A60026' }
    ]
  },
  'SumOfSolarRadiation': {
    items: [
      { value: '0', color: '#FFF7BC' },
      { value: '333333', color: '#FFE390' },
      { value: '666667', color: '#FED87A' },
      { value: '1000000', color: '#FECE64' },
      { value: '1333333', color: '#FBAC43' },
      { value: '1666667', color: '#F78921' },
      { value: '2000000', color: '#DD6912' },
      { value: '2333333', color: '#C34802' },
      { value: '2666667', color: '#953704' },
      { value: '3000000', color: '#662506' }
    ]
  }
};
